import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import InlineInputText from '@/components/calculators/InlineInputText';
import InfoCollapsible from '@/components/calculators/InfoCollapsible';
import MathFormulaDisplay from '@/components/calculators/MathFormulaDisplay';

const CalculatorTemplate = ({
  title,
  icon: Icon,
  inputText,
  inputFields,
  initialValues,
  onCalculate,
  infoTitle,
  infoContent,
  generalFormula,
  formulaDescription,
  result
}) => {
  const [formData, setFormData] = useState(initialValues);

  const handleInputChange = (newData) => {
    setFormData((prevData) => ({ ...prevData, ...newData }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onCalculate(formData);
  };

  return (
    <Card className="w-full max-w-3xl mx-auto">
      <CardHeader className="flex flex-row items-center space-x-4 p-4 sm:p-6">
        <Icon className="w-8 h-8 text-blue-500" />
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">{title}</h2>
      </CardHeader>
      <CardContent className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6 text-gray-700">
          <InlineInputText
            text={inputText}
            onInputChange={handleInputChange}
            inputFields={inputFields}
            values={formData}
          />

          <button
            type="submit"
            className="w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 bg-green-500 text-white rounded text-lg hover:bg-green-600 transition-colors"
          >
            Calculate
          </button>
        </form>

        {result}

        <InfoCollapsible 
          title={infoTitle}
          content={
            <>
              {infoContent}
              {generalFormula && (
                <MathFormulaDisplay formula={generalFormula} description={formulaDescription} />
              )}
            </>
          }
        />
      </CardContent>
    </Card>
  );
};

export default CalculatorTemplate;